export default "__VITE_ASSET__8e838cde__"